<template>
  <div>
    <v-container fluid pt-0 pb-0 px-0>
      <!-- México -->
      <v-tabs
        v-model="tab"
        background-color="#FAFAFA"
        color="primary"
        grow
        show-arrows
        @change="selectedVertical"
      >
        <v-tab
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in items"
          :key="item"
        >
          <v-card
            flat
          >
            <v-layout row wrap>
              <v-flex xs12 pt-8 pl-12>
                <h1>MEXICO</h1>
                <v-flex xs3 sm2 md1 pb-8 pr-12>
                  <hr style="border-color: #f05f32">
                </v-flex>
              </v-flex>
              <v-flex xs12 sm6 md4 px-12 pb-12>
                <div
                  v-for="select1 in selected1"
                  :key="select1"
                >{{ select1 }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 px-12 pb-12>
                <div
                  v-for="select2 in selected2"
                  :key="select2"
                >{{ select2 }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 px-12 pb-12>
                <div
                  v-for="select3 in selected3"
                  :key="select3"
                >{{ select3 }}</div>
              </v-flex>
            </v-layout>

            <!-- Costa Rica -->
            <v-layout v-if="selectedCR !== ''" row wrap style="background-color: #f05f32" white--text>
              <v-flex xs12 md7>
                <v-img width="100%" height="100%" transition="scale-transition" src="../assets/side_costarica.png"></v-img>
              </v-flex>
              <v-flex xs12 md5 pa-12>
                <h1>COSTA RICA</h1>
                <v-flex xs3 pb-12 pr-12>
                  <hr style="border-color: white">
                </v-flex>
                <v-flex xs12>
                  <div
                    v-for="selectCR in selectedCR"
                    :key="selectCR"
                  >{{ selectCR }}</div>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <!-- Marcas -->
      <v-layout row wrap style="background-color: #FAFAFA">
        <v-flex xs8 md11 pl-12 pt-8>
          <h1>BRANDS</h1>
          <v-flex xs6 sm2 md1 pb-8 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>
      <div v-if="windowSize >= 2" class="px-12" style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="4"
          :itemsToSlide="4"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in marcas" :key="index" :index="index">
            <img width="50%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>
      <div v-else style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="2"
          :itemsToSlide="2"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in clients" :key="index" :index="index">
            <img width="80%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>

      <!-- Contact -->
      <v-layout row wrap pa-8 text-center white--text class="contact" style="background-color: #2a2d30">
        <v-flex xs12>
          <h1>CONTACT</h1>
        </v-flex>
        <v-flex xs12 md6 px-8>
          <v-form v-model="form">
            <v-layout row wrap pa-8 text-center>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.company"
                  :rules="[() => mail.company.length >= 1 || 'Invalid name']"
                  label="Company name"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.telefono"
                  :rules="[() => mail.telefono.length >= 1 || 'Invalid phone']"
                  label="Phone"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.email"
                  :rules="[rules.email]"
                  label="Email"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="mail.mercado"
                  :items="mercadoVertical"
                  label="Vertical Market"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="mail.solucion"
                  :items="soluciones"
                  label="Solutions"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="mail.message"
                  :rules="[() => mail.message.length >= 1 || 'Invalid message']"
                  label="Project details"
                  solo
                  required
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn block color="#f05f32" :class="{'disable-events' : !form}" dark :loading="loading" @click="sendEmail">ENVIAR</v-btn>
              </v-flex>
              <v-flex v-if="responseMessage" xs12 pt-4>
                <h3 style="color: #FCB713">{{ responseMessage }}</h3>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
        <v-flex xs12 md6 pt-12>
          <div class="text pt-12"><b>CONTACT:</b></div>
          <div class="text">+52 81 8040 8510</div><br><br><br><br>

          <div class="text"><b>EMAIL:</b></div>
          <a href="mailto:contact@proainternational.com?" class="text" style="text-decoration: none; color: white;">contact@proainternational.com</a>
          <v-flex xs4 offset-xs4 pb-8>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>

      <!-- Nuestros Clientes -->
      <v-layout row wrap style="background-color: #FAFAFA">
        <v-flex xs8 md11 pl-12 pt-8>
          <h1>OUR CLIENTS</h1>
          <v-flex xs6 sm2 md1 pb-8 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>
      <div v-if="windowSize >= 2" class="px-12" style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="4"
          :itemsToSlide="4"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in clients" :key="index" :index="index">
            <img width="50%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>
      <div v-else style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="2"
          :itemsToSlide="2"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in clients" :key="index" :index="index">
            <img width="80%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'home',
  components: {
    Hooper,
    Slide
  },
  data: () => ({
    tab: null,
    items: ['hotel', 'hospital', 'government', 'industrial', 'entertainment', 'residential', 'corporative', 'comercial', 'education', 'penitentiary'],
    loading: false,
    responseMessage: '',
    done: false,
    form: false,
    vertical: '',
    selected1: '',
    selected2: '',
    selected3: '',
    selectedCR: '',
    hoteleria1: ['AC Marriott - Guadalajara', 'Aqua Lat 20', 'Fairfield Inn', 'Fairfield & Courtyard', 'Vallejo Fiesta Americana', 'Fiesta Inn La Fe Monterrey', 'Grace Bay Suites (Turcos & Caicos) Hampton Inn', 'Piedras Negras', 'Hilton Garden Inn', 'Aloft Hotel- Lindura', 'Best Western Hotel', 'Camino Real Hotel', 'City Express Hotel - Zamora', 'Conrad Hotel', 'Contempo Hotel', 'Country Inn Suites Hotel', 'Crowne Plaza Hotel', 'Double Tree Hotel', 'Emperador Hotel (Panama)', 'Encore Hotel - Puebla'],
    hoteleria2: ['Extended Suites Hotel', 'Fiesta Inn Hotel', 'Gamma Hotel', 'Hampton Inn Hotel', 'Hilton Garden Inn Hotel', 'Holiday Inn Hotel', 'Horne 2 Suites Hotel', 'Hyatt Hotel', 'Hyatt Place  Hotel - Panama', 'Ibis Hotel / Novotel', 'JW Marriott Hotel', 'Koral Center Hotel Los Cabos', 'Marriott Courtyard Hotel - Saltillo', 'Mundo Imperial Hotel', 'NH Collection Hotel - Leon', 'One Hotel - North Guadalajara', 'Posadas Hotel - Guadalajara', 'Punta Pacifica - Hotel', 'Radisson Hotel', 'Real Inn Hotel'],
    hoteleria3: ['Safi Hotel', 'Sea of Cortez Hotel', 'Secrets Hotel', 'Sheraton Maria Isabel Hotel', 'Stay Bridge Hotel', 'Tamarindo Hotel', 'Terranova Hotel', 'Hyatt Regency Guadalajara', 'Marriott Playa El Ague Isla Margarita (Venezuela)', 'Santa Fe Hills Sleep Inn Monterrey Sonesta', 'Amador Suites Central Park Suites (Costa Rica)', 'Terranova', 'Westin (Peru)', 'Fiesta Americana Tlalnepantla SI', 'Aloft Hotel - Celaya SI', 'Double Tree Celaya', 'Fiesta Americana Hotel Citadela SLP', 'Aloft Queretaro'],
    hoteleriaCR: ['Holiday Inn Escazu', 'Park Inn San Jose', 'Hyatt Place Pinares', 'JW Marriot Conchal Guanacaste', 'Secrets Hotel Guanacaste', 'Fairfield Hotel San Salvador', 'Hilton Garden Inn Sabana', 'Gran Hotel Costa Rica by Curio Collection'],
    hospitalario1: ['Clinic Parrita', 'Arthrocare', 'Puerta de Hierro Medical Center', 'Zambrano Hellion Medical Center', 'MINSA Clinic Kuna Yala', 'MINSA Clinic Pacora', 'MINSA Clinic Puerto Caimito', 'MINSA Clinic Rio Sereno', 'Minsa Clinic Capsi', 'ABC Hospital', 'Cartago Hospital', 'Hospital Center Los Cabos', 'Christus Muguerza Hospital', 'Hospital de Niños', 'Gran Turk Hospital(Turks & Caicos Islands)', 'Los Angeles Hospital', 'OCA Hospital', 'Osler Hospital'],
    hospitalario2: ['Providenciales Hospital (Turks & Caicos Islands)', 'Ixtapaluca Regional Hospital', 'San Ángel Inn Hospital Patriotismo', 'Saint Joseph Hospital (Trinidad y Tobago)', 'San Felipe de Jesús Hospital', 'Tony Facio Hospital', 'San José Hospital Monterrey', 'Zambrano Hospital Floor 4 Leon, Gto', 'IMSS Metepec / Mérida / Reynosa', 'Medicina Nuclear', 'San Juan de Dios Hospital', 'Radiology Hospital México Hospital IMSS', 'Regional Quereetaro Hospital Universitario'],
    hospitalarioCR: ['San Jose Childrens Hospital', 'Calderón Guardia Hospital East Wing', 'Hospital de Alajuela'],
    gobierno1: ['Toluca Airport', 'Monterrey International Airport', 'Juan Santamaría International Airport', 'Monterrey Airport (Terminal B) C5', 'American Consulate – Santa Catarina', 'Desarrollo Integral para la Familia (DIF)', 'Mexican Senate Building IFE La Paz', 'PFP (Aguascalientes / Escobedo / Matamoros / Veracruz)', 'Cedereyta Refinery', 'Banco de Mexico SI', 'OMA SLP', 'Hermosillo Judiciary'],
    gobiernoCR: ['Liberia Guanacaste International Airport', 'Juan Santamaria Airport Domestic Terminal'],
    industrial1: ['Aerotech', 'AIRBUS', 'Akiseat', 'Avantor', 'Bocar', 'Bombardier', 'British American Tobacco', 'Casa cuervo Planta la Rojeña', 'Cedis-Walmart', 'Cementos Panamá Colón', 'Cessna', 'Coluin-Manitowoc', 'Constela', 'Contel', 'Continental', 'Cooper', 'CPA', 'Cummins Motors San Luis', 'CUPRUM', 'Danhill', 'Daykyonish', 'Denso', 'DHL', 'Draexelmier', 'EATON', 'Entertek', 'ETILENO XX1', 'Exedy Dynax Faurencia Finsa', 'Fokker', 'Gemo'],
    industrial2: ['General Motors Silao', 'Halliburton', 'Hersheys', 'IAC', 'IMSA', 'Interceramic', 'International Monterrey', 'Javil Circuit Chihuahua', 'Johnson Electric Zacatecas', 'KIA MOBIS', 'Kraft de México', 'LG', 'L’Oréal', 'Martell', 'MD Electronics', 'MAZDA', 'MOBIS RDC', 'MONDELEZ', 'Multitenat', 'Nestlé', 'Nissan', 'Nivea', 'Noranco', 'Nucitec', 'Panduit', 'PEPSICO', 'Peñafiel', 'Pollos Ivy', 'Procter & Gamble', 'Prologis'],
    industrial3: ['RYDER de México', 'Ryobi', 'Sanden', 'Shoei Abasolo Gto.', 'Siemens', 'Spring Windows', 'Steelcase', 'Sisamex', 'Safran Querétaro', 'Tata Consultancy Takata', 'THK', 'Toyota Querétaro', 'Trane', 'Trostel México', 'TUBACERO', 'TYDEN', 'Audi México', 'BMW', 'Toyota Bajío Lenovo', 'Golden Foods Amazon', 'Nestle Purina Flex & Gate', 'JCS', 'Jatco', 'Kromber', 'Ball Beverage'],
    entretenimiento1: ['Arena México', 'Cinépolis', 'Cinépolis Metromall', 'ESPN', 'BBVA Bancomer Stadium', 'Golden Foods', 'Irapuato City Theater', 'Los Mochis Theater'],
    residencial1: ['Aqua', 'Arcángeles |||', 'Atria', 'Brisas de Amador', 'Colinas Diamante', 'Loft Condominums', 'Cumbres de Santa Fe', 'El Legado Eva', 'Fuentes del Valle', 'Garza Sada 1892', 'Kaláh', 'KOI', 'La Capital', 'Latitud', 'Latitud Polanco', 'LEVANT Boca Del Río', 'LEVANT Dinastía', 'LIU Manzanares'],
    residencial2: ['Meridiano Metropolitan Center Miyana', 'Plastic Omnium SLP', 'Reforma 509', 'Residencial Torre Iris', 'Santa Fe Hills', 'Saqqara', 'Ana Cordillera Tower', 'Domminium Tower', 'Magma Towers', 'Sofía Tower', 'TULÉ VAO', 'Vento Sonoma', 'Laguna Park Tower'],
    corporativo1: ['ABC Inoac', 'Afirme', 'AMAZON', 'Arca - Continental', 'Banamex', 'Banco de México DF', 'Banco de México NL', 'Banorte', 'Bancomer Operative Center', 'Data Center', 'Punto Polanco', 'Cervantes Saavedra', 'Cuauhtémoc Moctezuma Brewery', 'CISCO', 'Cooper Power', 'Corporativo Concreto', 'CREDIT SUISSE', 'Chufani', 'Down Town Santa Fe', 'Financial Tower', 'Garniel'],
    corporativo2: ['Hewlett Packard', 'HSBC', 'Invercap l', 'JP MORGAN CHASE', 'Mario Pani', 'Matber', 'Microsoft', 'Nextel', 'AIG Offices', 'Axo Offices', 'Polycom', 'Prudential', 'Reforma Diana', 'SAT', 'Terret', 'Bancomer Tower', 'Business Hub Tower', 'CEDETEL Tower', 'Fusion AT&T Tower', 'Torres Moradas'],
    comercial1: ['Carl’s Jr', 'Portimao Marina Resort Mall', 'La Paz Convention Center', 'San José del Cabo Convention Center', 'Tec Guadalajara Congress Center', 'Irapuato Convention Center', 'Palacio de los Deportes', 'Sordo Madaleno Mall (Veracruz y Querétaro)', 'Centro Comercial Fashion Mall', 'Parque Puebla Mall', 'Las Antenas Mall'],
    comercial2: ['Guess Fashion Mall Tampico', 'H&M', 'Oxxo Pabellón Cultural Los Cabos', 'Palacio de las Artes', 'Tempo Plaza', 'Santa Isabel Plaza'],
    educacion1: ['American School', 'Himalaya International School', 'Swiss School Mexico', 'School of Economics', 'Smithsonian Research Institute', 'IPADE', 'ITESM', 'Roberto Garza Sada Center', 'Tec Milenio', 'UDEM', 'UNAM', 'Full Integration Presidency'],
    penitenciaria1: ['Cereso Guanajuato', 'Cereso Papantla', 'Cereso San Miguel'],
    penitenciariaCR: ['UAI Integral Attention Center La Reforma', 'UAI Integral Attention Center Pococi', 'UAI Integral Attention Center Zeledon'],
    mercadoVertical: ['Hospital', 'Education', 'Hotel', 'High Security', 'Check Curriculum'],
    soluciones: ['Metallic and Wooden Doors', 'Anden Equipment'],
    mail: {
      company: '',
      telefono: '',
      email: '',
      message: '',
      mercado: '',
      solucion: ''
    },
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid email'
      }
    },
    marcas: [
      { src: require('../assets/Marcas/allegion.png') },
      { src: require('../assets/Marcas/amarr.png') },
      { src: require('../assets/Marcas/assa-abloy.png') },
      { src: require('../assets/Marcas/asturmex.png') },
      { src: require('../assets/Marcas/cookson.png') },
      { src: require('../assets/Marcas/dormakaba.png') },
      { src: require('../assets/Marcas/dynaco.png') },
      { src: require('../assets/Marcas/eliason.png') },
      { src: require('../assets/Marcas/gensteel.png') },
      { src: require('../assets/Marcas/metal-manufacturing.png') },
      { src: require('../assets/Marcas/pentalift.png') },
      { src: require('../assets/Marcas/raynor.png') },
      { src: require('../assets/Marcas/rediframe.png') },
      { src: require('../assets/Marcas/stanley.png') },
      { src: require('../assets/Marcas/timely.png') },
      { src: require('../assets/Marcas/wks.png') }
    ],
    clients: [
      { src: require('../assets/Clientes/amazon.png') },
      { src: require('../assets/Clientes/arca-continental.png') },
      { src: require('../assets/Clientes/audi.png') },
      { src: require('../assets/Clientes/BBVA.png') },
      { src: require('../assets/Clientes/denso.png') },
      { src: require('../assets/Clientes/GM.png') },
      { src: require('../assets/Clientes/hampton.png') },
      { src: require('../assets/Clientes/intel.png') },
      { src: require('../assets/Clientes/pepsi.png') },
      { src: require('../assets/Clientes/st_joseph.png') }
    ]
  }),
  computed: {
    windowSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 0
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 3
        case 'xl': return 4
        default: return 0
      }
    }
  },
  methods: {
    selectedVertical () {
      switch (this.tab) {
        case 0:
          this.selected1 = this.hoteleria1
          this.selected2 = this.hoteleria2
          this.selected3 = this.hoteleria3
          this.selectedCR = this.hoteleriaCR
          this.$router.replace('/verticales/hotel')
          break
        case 1:
          this.selected1 = this.hospitalario1
          this.selected2 = this.hospitalario2
          this.selected3 = ''
          this.selectedCR = this.hospitalarioCR
          this.$router.replace('/verticales/hospital')
          break
        case 2:
          this.selected1 = this.gobierno1
          this.selected2 = ''
          this.selected3 = ''
          this.selectedCR = this.gobiernoCR
          this.$router.replace('/verticales/goverment')
          break
        case 3:
          this.selected1 = this.industrial1
          this.selected2 = this.industrial2
          this.selected3 = this.industrial3
          this.selectedCR = ''
          this.$router.replace('/verticales/industrial')
          break
        case 4:
          this.selected1 = this.entretenimiento1
          this.selected2 = ''
          this.selected3 = ''
          this.selectedCR = ''
          this.$router.replace('/verticales/entertainment')
          break
        case 5:
          this.selected1 = this.residencial1
          this.selected2 = this.residencial2
          this.selected3 = ''
          this.selectedCR = ''
          this.$router.replace('/verticales/residential')
          break
        case 6:
          this.selected1 = this.corporativo1
          this.selected2 = this.corporativo2
          this.selected3 = ''
          this.selectedCR = ''
          this.$router.replace('/verticales/corporative')
          break
        case 7:
          this.selected1 = this.comercial1
          this.selected2 = this.comercial2
          this.selected3 = ''
          this.selectedCR = ''
          this.$router.replace('/verticales/comercial')
          break
        case 8:
          this.selected1 = this.educacion1
          this.selected2 = ''
          this.selected3 = ''
          this.selectedCR = ''
          this.$router.replace('/verticales/education')
          break
        case 9:
          this.selected1 = this.penitenciaria1
          this.selected2 = ''
          this.selected3 = ''
          this.selectedCR = this.penitenciariaCR
          this.$router.replace('/verticales/penitentiary')
          break
      }
    },
    selectTab () {
      switch (this.vertical) {
        case 'hotels':
          this.tab = 0
          break
        case 'hospital':
          this.tab = 1
          break
        case 'government':
          this.tab = 2
          break
        case 'industrial':
          this.tab = 3
          break
        case 'entertainment':
          this.tab = 4
          break
        case 'residential':
          this.tab = 5
          break
        case 'corporative':
          this.tab = 6
          break
        case 'comercial':
          this.tab = 7
          break
        case 'education':
          this.tab = 8
          break
        case 'penitentiary':
          this.tab = 9
          break
      }
      this.selectedVertical()
    },
    sendEmail () {
      this.loading = true
      var emailjs = window.emailjs
      emailjs.send('default_service', 'template_tI9e37dJ_clone', this.mail).then(response => {
        console.log('Success!', response.status, response.text)
        this.loading = false
        this.responseMessage = 'Your message has been sent!'
        this.mail = {}
      }, error => {
        console.log('Failed...', error)
        this.loading = false
        this.responseMessage = 'Error, try sending the message again.'
      })
    },
    addHashToLocation (params) {
      history.pushState(
        {},
        null,
        this.$route.path + (params)
      )
    }
  },
  created () {
    this.vertical = this.$route.params.vertical
    this.selectTab()
  }
}
</script>

<style>
p {
  text-align: justify;
  text-align-last: left;
}
.line {
  position: relative;
  width: 13%;
  border-width: 0.1em;
  top: 2em;
  right: 4.5em;
  border-color: #f05f32;
  z-index: 0;
}
.img__Rectangle {
  height: 100px;
  width: 50px;
  background-color: #303336;
  z-index: 0;
}
.contact {
  background-image: url('../assets/hoteleria_contacto.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
.header {
  background-image: url('../assets/header_hoteleria.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
.disable-events {
  pointer-events: none
}
.text {
  font-size: 180%
}
</style>
